import { IdNameApiModel } from '@app/api/api-models/IdNameApiModel';
import { PhaseSelectorApiModel } from '@app/api/api-models/form-instance/PhaseSelectorApiModel';
import { AssignmentSkillSelectorApiModel } from './AssignmentSkillSelectorApiModel';
import { AssignmentPerformanceCategorySelectorApiModel } from './AssignmentPerformanceCategorySelectorApiModel';
import { ActivityTypeListApiModel } from '@app/api/api-models';
import { AssignmentCallTypeSelectorApiModel } from '@app/api/api-models/pending-tasks/AssignmentCallTypeSelectorApiModel';

export class AssignmentSelectorsApiModel {
  public Phases = new Array<PhaseSelectorApiModel>();
  public Skills = new Array<AssignmentSkillSelectorApiModel>();
  public SkillHeadings = new Array<IdNameApiModel>();
  public PerformanceCategories = new Array<AssignmentPerformanceCategorySelectorApiModel>();
  public CallTypes = new Array<AssignmentCallTypeSelectorApiModel>();
  public CallTypeHeadings = new Array<IdNameApiModel>();
  public PerformanceCategoryHeadings = new Array<IdNameApiModel>();
  public ActivityTypes = new Array<ActivityTypeListApiModel>();

  public deserialize(data: Object): AssignmentSelectorsApiModel {
    Object.assign(this, data);

    this.ActivityTypes = this.ActivityTypes?.map((x) => new ActivityTypeListApiModel().deserialize(x)) || [];
    this.CallTypes = this.CallTypes || [];
    this.CallTypeHeadings = this.CallTypeHeadings || [];
    this.Skills = this.Skills || [];
    this.SkillHeadings = this.SkillHeadings || [];
    this.PerformanceCategories = this.PerformanceCategories || [];
    this.PerformanceCategoryHeadings = this.PerformanceCategoryHeadings || [];
    this.Phases = this.Phases || [];

    return this;
  }
}
